var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHighlightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 530,
    viewBox: "0 0 788 530",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9815_25096)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9815_25096)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 788,
    height: 530,
    rx: 8,
    fill: "#E7F3FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788 382.02C668.779 352.934 535.142 336.637 394 336.637C252.858 336.637 119.223 352.934 0 382.02V667.575H788V382.02Z",
    fill: "#68C02F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788 463.21C668.779 442.396 535.142 430.732 394 430.732C252.858 430.732 119.223 442.396 0 463.21V667.555H788V463.21Z",
    fill: "#57AA22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M788 515.155L638.906 477.808C608.837 419.061 510.58 375.986 394 375.986C277.42 375.986 179.161 419.059 149.094 477.808L0 515.155V655.399L175.382 587.145C219.767 628.018 301.055 655.399 394 655.399C486.946 655.399 568.235 628.018 612.618 587.145L788 655.399V515.155Z",
    fill: "#EEBB34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.845 511.826C604.845 570.957 510.447 618.891 393.999 618.891C277.552 618.891 183.154 570.955 183.154 511.826C183.154 452.694 277.552 404.758 393.999 404.758C510.447 404.758 604.845 452.694 604.845 511.826Z",
    stroke: "white",
    strokeWidth: 3.8927,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 532.889C415.858 532.889 433.577 523.151 433.577 511.14C433.577 499.128 415.858 489.391 394 489.391C372.143 489.391 354.424 499.128 354.424 511.14C354.424 523.151 372.143 532.889 394 532.889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 191.6C0 191.6 139.824 249.887 404.667 249.887C669.51 249.887 787.658 192.172 787.658 192.172V438.144C507.252 417.953 227.213 416.753 0 438.144V191.6Z",
    fill: "#2D2F31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 160C0 160 143.54 219.506 406.802 219.506C670.064 219.506 787.658 160.852 787.658 160.852V192.177C787.658 192.177 671.266 249.893 406.802 249.893C142.339 249.893 0 191.605 0 191.605V160Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 307.617C0 307.617 112.172 345.085 410.564 345.085C708.956 345.085 787.658 308.702 787.658 308.702V325.905C787.658 325.905 707.883 357.82 411.002 357.82C114.121 357.82 0 325.905 0 325.905V307.617Z",
    fill: "#EEF1F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8247 225.092L30.3782 230.335L22.6875 232.004L30.3782 233.671L32.8247 238.913L35.2711 233.671L42.9618 232.004L35.2711 230.335L32.8247 225.092Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2348 287.598L54.7868 292.841L47.0977 294.508L54.7868 296.176L57.2348 301.419L59.6813 296.176L67.372 294.508L59.6813 292.841L57.2348 287.598Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.135 303.559L181.687 308.802L173.998 310.469L181.687 312.138L184.135 317.38L186.582 312.138L194.272 310.469L186.582 308.802L184.135 303.559Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.424 252.293L124.978 257.536L117.287 259.204L124.978 260.873L127.424 266.116L129.871 260.873L137.561 259.204L129.871 257.536L127.424 252.293Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.379 271.947L262.827 266.704L270.518 265.036L262.827 263.368L260.379 258.125L257.933 263.368L250.242 265.036L257.933 266.704L260.379 271.947Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.363 321.689L271.915 326.932L264.225 328.6L271.915 330.268L274.363 335.512L276.81 330.268L284.501 328.6L276.81 326.932L274.363 321.689Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.182 238.913L761.63 233.671L769.319 232.004L761.63 230.335L759.182 225.092L756.736 230.335L749.045 232.004L756.736 233.671L759.182 238.913Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.045 301.419L751.493 296.176L759.183 294.508L751.493 292.841L749.045 287.598L746.599 292.841L738.908 294.508L746.599 296.176L749.045 301.419Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.584 304.906L602.136 310.149L594.447 311.817L602.136 313.485L604.584 318.728L607.032 313.485L614.723 311.817L607.032 310.149L604.584 304.906Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.24 321.689L501.792 326.932L494.102 328.6L501.792 330.268L504.24 335.512L506.687 330.268L514.376 328.6L506.687 326.932L504.24 321.689Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.264 256.586L669.818 261.829L662.127 263.497L669.818 265.166L672.264 270.409L674.712 265.166L682.403 263.497L674.712 261.829L672.264 256.586Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.2 258.125L549.754 263.368L542.064 265.036L549.754 266.704L552.2 271.947L554.648 266.704L562.339 265.036L554.648 263.368L552.2 258.125Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8247 336.955L30.3782 342.198L22.6875 343.866L30.3782 345.535L32.8247 350.777L35.2711 345.535L42.9618 343.866L35.2711 342.198L32.8247 336.955Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2348 395.156L54.7868 400.398L47.0977 402.067L54.7868 403.735L57.2348 408.978L59.6813 403.735L67.372 402.067L59.6813 400.398L57.2348 395.156Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.135 401.859L181.687 407.101L173.998 408.769L181.687 410.438L184.135 415.681L186.582 410.438L194.272 408.769L186.582 407.101L184.135 401.859Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.424 364.145L124.978 369.385L117.287 371.054L124.978 372.723L127.424 377.966L129.871 372.723L137.561 371.054L129.871 369.385L127.424 364.145Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.379 369.99L257.933 375.232L250.242 376.901L257.933 378.569L260.379 383.812L262.827 378.569L270.518 376.901L262.827 375.232L260.379 369.99Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M759.182 336.955L756.736 342.198L749.045 343.866L756.736 345.535L759.182 350.777L761.63 345.535L769.319 343.866L761.63 342.198L759.182 336.955Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M749.045 395.156L746.599 400.398L738.908 402.067L746.599 403.735L749.045 408.978L751.493 403.735L759.183 402.067L751.493 400.398L749.045 395.156Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604.584 403.217L602.136 408.46L594.447 410.128L602.136 411.796L604.584 417.039L607.032 411.796L614.723 410.128L607.032 408.46L604.584 403.217Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M672.264 368.438L669.818 373.68L662.127 375.348L669.818 377.016L672.264 382.259L674.712 377.016L682.403 375.348L674.712 373.68L672.264 368.438Z",
    fill: "#3C4044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.2 369.99L549.754 375.232L542.064 376.901L549.754 378.569L552.2 383.812L554.648 378.569L562.339 376.901L554.648 375.232L552.2 369.99Z",
    fill: "#3C4044"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9815_25096",
    x: 0,
    y: 0,
    width: 788,
    height: 530,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 0 0.941176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9815_25096"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9815_25096"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 788,
    height: 530,
    rx: 8,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightBg);
export default __webpack_public_path__ + "static/media/highlightBg.1e6da0919865f4b241e41d32a167d1a4.svg";
export { ForwardRef as ReactComponent };